module.exports = __webpack_public_path__ + "static/img/pay1.84bcfed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pay1.png
// module id = RA4H
// module chunks = 1